<template>
  <div id="generic">
    <div class="generic-left" :style="{ height: '90vh' }">
      <div class="collapsed-left" @click="toggleCollapsed">
        <a-icon :type="collapsed ? 'left' : 'right'" />
      </div>
      <div class="generic-left-menu" id="gmc-menu-container">
        <a-menu
          mode="inline"
          theme="light"
          :inlineCollapsed="collapsed"
          @click="selectMenuApi"
        >
          <template v-for="item in gmcMenulist">
            <a-menu-item v-if="!item.children" :key="item.functionUid">
              <i class="anticon anticon-environment">
                <span class="iconfont" v-bind:class="item.icon"></span>
              </i>
              <span>{{ item.funcName }}</span>
            </a-menu-item>
            <sub-menu v-else :menu-info="item" :key="item.functionUid" />
          </template>
        </a-menu>
      </div>
    </div>

    <div class="generic-right">
      <div class="genericRight-CollapsePanel">
        <a-collapse activeKey="1" :bordered="false">
          <a-collapse-panel key="1" :style="customStyle">

            <template slot="header">
              <a-tooltip placement="topLeft" >
                <template slot="title">
                  {{ targetGenericTitle }}
                </template>
                <span style="display: inline-block;overflow: hidden; white-space:nowrap; text-overflow:ellipsis;">{{ targetGenericTitle }}</span>
              </a-tooltip>

            </template>

            <div class="componts-btn">
              <div class="componts-btn-left">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.Add') }}</span>
                  </template>
                  <img class="ml10 sbxs" @click="AddEditGeneric('add')"  src="../../assets/img/ss-add.png"  width="22" height="22">
                </a-tooltip>
                <a-popconfirm
                  :title="$t('generic.AreyoudeleTask')"
                  @confirm="deleteGeneric"
                  :okText="$t('generic.Yes')"
                  :cancelText="$t('generic.No')"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>{{ $t('generic.Delete') }}</span>
                    </template>
                    <img style="margin:0 10px" class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                  </a-tooltip>
                </a-popconfirm>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.Edit') }}</span>
                  </template>
                  <img class="mr10 sbxs" @click="AddEditGeneric('edit')" src="../../assets/img/ss-edit.png"  width="22" height="22">
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.Publish') }}</span>
                  </template>
                  <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="property-safety"
                    @click="fabuGeneric"></a-button>
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.Copy') }}</span>
                  </template>
                  <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="copy"
                    :disabled="copyDisabled"
                    style="background: #8e8888;border:none"
                    @click="copyGeneric"
                  ></a-button>
                </a-tooltip>
                <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t('generic.CreateGenericData') }}</span>
                </template>
                <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="plus-circle"
                        @click="createGenericBtn"
                ></a-button>
              </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.AppendGenericData') }}</span>
                  </template>
                  <a-button
                          size="small"
                          type="primary"
                          shape="circle"
                          icon="plus-square"
                          @click="appendGenericData('add')"
                  ></a-button>
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.ConfigSQL') }}</span>
                  </template>
                  <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="setting"
                    @click="openConfigBySql"
                  ></a-button>
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.DeleteGenericData') }}</span>
                  </template>
                  <img @click="appendGenericData('delete')" class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                </a-tooltip>
                <span class="ml4">
                  <a-input-search size="small" placeholder="input search text" style="width: 200px"  v-model="genericSearchVal" @search="genericSearch"/>
                </span>

                <a-button   size="small" type="primary"  style="margin-left: 12px" @click="refreshTab" >Refresh</a-button>
                <a-button  class="mg5" size="small" type="primary" @click="clearRedisCache" >Clear Redis Cache</a-button>
              </div>
              <div class="componts-btn-right">
                <a-pagination
                  size="small"
                  :total="genericHeaderPage.totalElements"
                  v-model="genericHeaderPage.genericCurrent"
                  :showTotal="total => `Total ${genericHeaderPage.totalElements} Records`"
                  :pageSize="pageSize"
                  @change="genericChage"/>
              </div>
            </div>
            <!--表格一-->
            <a-table
              bordered
              :rowSelection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange
              }"
              :columns="columns"
              :dataSource="genericList"
              :pagination="nopagination"
              size="small"
              :scroll="{ x: '110%'}"
              :loading="genericHeaderLoading"
              :customRow="customRowEvent"
              :rowClassName="rowClassName"
              :locale="tabelText"
            >
              <template
                v-for="(item, index) in scopedSlotsArray"
                :slot="item"
                slot-scope="text"
              >
                <span :key="index">
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span
                        class="tableFontSize"
                        v-if="item !== 'isDefaultMod'"
                        >{{
                          text === "1" || text === true
                            ? "Yes"
                            : text === "0" || text === false
                            ? "No"
                            : text === null
                            ? "-"
                            : text
                        }}</span
                      >
                      <span class="tableFontSize" v-else>{{
                        text ? "Startup generic of module" : "-"
                      }}</span>
                    </template>
                    <div class="tableFontSize" v-if="item !== 'isDefaultMod'">
                      {{
                        text === "1" || text === true
                          ? "Yes"
                          : text === "0" || text === false
                          ? "No"
                          : text === null
                          ? "-"
                          : text
                      }}
                    </div>
                    <div v-else>
                      <a-icon
                        type="check-circle"
                        style="color: #1890ff"
                        v-if="text === '1'"
                      />
                    </div>
                  </a-tooltip>
                </span>
              </template>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </div>
      <div class="card-container">
        <a-tabs :animated="animated" @change="tabsChange" v-if="targetUidClass">
          <a-tab-pane :tab="$t('generic.DBSchema')" key="1">
            <a-row style="height: 50vh;overflow-y: auto">
              <db-schema v-on:QuerydbSelectList="getdbselectlist" ref="refDbSchema"></db-schema>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.PageProperty')" key="2">
            <a-row style="height: 50vh;overflow-y: auto">
            <page-property
              :pagedbSelectList="pagedbSelectList"
              :key="strKey"
            ></page-property>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.SQL')" key="3">
            <a-row style="height: 50vh;overflow-y: auto">
            <generic-sql></generic-sql>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.Behavior')" key="4">
            <a-row style="height: 60vh">
               <be-havior></be-havior>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.SubPage')" key="5">
            <a-row style="height: 50vh;overflow-y: auto">
               <sub-page></sub-page>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.SearchTemplate')" key="6">
            <a-row style="height: 50vh;overflow-y: auto">
              <search-tml :uid="targetUidClass"></search-tml>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :tab="$t('queryCondition')" key="7">
            <a-row>
              <query-condition ref="refQueryCondition" :pagedbSelectList="pagedbSelectList" :selectedModuleCode="selectedModuleCode" @clearSelected="clearSelectedData"></query-condition>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <!--新增list-->
    <a-modal
      :title="$t('generic.Add')"
      v-model="visibleAddList"
      width="60%"
      @cancel="resetting"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="danger" @click="resetting">{{ $t('publicLang.Clear') }}</a-button>
        <a-button type="primary" @click="getGenericConfig" :loading="loadingBtn">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="form">
        <a-row :gutter="24" style="margin-top: 20px">
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.GenericName')"
              v-bind="formItemLayout"
            >
              <a-input
                :placeholder="$t('generic.GenericName')"
                autocomplete="off"
                v-decorator="[
                  'genericName',
                  {
                    initialValue: editInitialValue.GenericName,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                :options="ModulesList"
                expandTrigger="hover"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'module',
                  {
                    initialValue: [
                      editInitialValue.Module,
                      editInitialValue.subModule
                    ],
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.Function')"
              v-bind="formItemLayout"
            >
              <a-select
                style="width: 100%"
                allowClear
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'function',
                  {
                    initialValue: editInitialValue.FunctionKey,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in functionList"
                  :key="index"
                  :value="item.functionKey"
                >
                  {{ item.functionValue }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.PageTitle')"
              v-bind="formItemLayout"
            >
              <a-input
                autocomplete="off"
                :placeholder="$t('generic.PageTitle')"
                v-decorator="[
                  'pageTitle',
                  {
                    initialValue: editInitialValue.PageTitle
                  }
                ]"
              />
            </a-form-item>
          </a-col>
<!--          <a-col :span="12"></a-col>-->
          <a-col :span="12">
            <a-form-item :label="$t('generic.ForOption')" v-bind="formItemLayout">
              <a-switch
                v-decorator="[
                  'isOption',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.isOption === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.IsPaging')" v-bind="formItemLayout">
              <a-switch
                v-decorator="[
                  'isPaging',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.IsPaging === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.Description')"
              v-bind="formItemLayout"
            >
              <a-textarea
                :placeholder="$t('generic.Description')"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-decorator="[
                  'description',
                  {
                    initialValue: editInitialValue.Description
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.StartupModule')" v-bind="formItemLayout">
              <a-switch
                v-decorator="[
                  'isDefaultMod',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.isDefaultMod === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>

           <a-col :span="12">
            <a-form-item :label="$t('generic.UseViewSQL')" v-bind="formItemLayout">
              <a-switch
                v-decorator="[
                  'useViewSql',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.useViewSql === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12"></a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.IgnoreCount')" v-bind="formItemLayout">
              <a-switch
                v-decorator="[
                  'ignoreCount',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.ignoreCount
                  }
                ]"
              />
            </a-form-item>
          </a-col>




        </a-row>
      </a-form>
    </a-modal>
    <!--append Delete-->
    <a-modal
            :title="appendDeleteVisGenDataType == 'add' ? 'Append Generic Data' : 'Delete Generic Data'"
            v-model="appendDeleteVisGenData"
            width="60%"
            @cancel="genericDataCancel('e')"
    >
      <template slot="footer">
        <a-button type="primary" @click="subMitAppendDelGeneric">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="appendDelGenericForm">
        <a-row>
          <a-col>
            <a-form-item :label="$t('generic.TableViewName')" v-bind="formItemLayout">
              <a-input
                size="small"
                 v-decorator="[
                  'tableName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :label="$t('generic.FiledName')" v-bind="formItemLayout">
              <a-input
                 size="small"
                 v-decorator="[
                  'fieldName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  <!--created generic-->
    <a-modal
            :title="$t('generic.CreateGenericData')"
            v-model="createGenericVis"
            width="75%"
            @cancel="genericDataCancel('a')"
    >
      <template slot="footer">
        <a-button type="primary" @click="subMitCreateGeneric">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-row>
        <a-form :form="createGenericForm">
          <a-col :span="24">
            <span class="creaGenericTitle">{{ $t('generic.Basic') }}</span>
          </a-col>
          <a-col :span="12">
            <!--            <a-form-item :label="$t('generic.TableViewName')" v-bind="formItemLayout">-->
            <!--              <a-input-->
            <!--                size="small"-->
            <!--                v-decorator="[-->
            <!--                  'tableName',-->
            <!--                  {rules: [{ required: true, message: $t('publicLang.Required') }]}-->
            <!--                ]"-->
            <!--              />-->
            <!--            </a-form-item>-->
            <a-form-item :label="$t('generic.TableViewName')" v-bind="formItemLayout">
              <a-select
                      size="small"
                      v-decorator="[
                        'tableName',
                         {rules: [{ required: true, message: $t('publicLang.Required') }]}
                       ]"
                      show-search
                      allow-clear
                      mode="combobox"
                      placeholder="填写或者选择表名、视图(e.g.: T_ASN_DETAIL)"
                      :options="tableSelect.map(value => ({ value, label: value }))"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ModuleCode')" v-bind="formItemLayout">
              <a-select
                      size="small"
                      v-decorator="[
                    'moduleCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
                      show-search
                      allow-clear
                      mode="combobox"
                      placeholder="填写或者选择模块代码,填写不存在会新建(e.g.: ASN)"
                      :options="moduleCodeSelect.map(value => ({ value, label: value }))"
                      @change="moduleCodeSelectChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.SubModuleCode')" v-bind="formItemLayout">
              <a-select
                      size="small"
                      v-decorator="[
                  'subModuleCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
                      show-search
                      allow-clear
                      mode="combobox"
                      placeholder="填写或者选择子模块代码,填写不存在会新建(e.g.: ASN_DETAIL)"
                      :options="subModuleCodeSelect.map(value => ({ value, label: value }))"
              />
            </a-form-item>
          </a-col>


          <a-col :span="12">
            <a-form-item :label="$t('generic.SubModuleName')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      placeholder="选择子模块名称"
                      v-decorator="[
                  'subModuleName',
                  {rules: [{ required: false, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>




          <a-col :span="24">{{ $t('generic.GenericMenu') }}</a-col>

          <!--          <a-col :span="12">-->
          <!--            <a-form-item :label="$t('generic.FunctionLevel')" v-bind="formItemLayout">-->
          <!--              <a-select-->
          <!--                      style="width: 100%"-->
          <!--                      size="small"-->
          <!--                      @change="levelChang"-->
          <!--                      v-decorator="[-->
          <!--                      'geMenuLevel',-->
          <!--                    {rules: [{ required: true, message: $t('publicLang.Required') }]}-->
          <!--                    ]">-->
          <!--                <a-select-option value="1">1</a-select-option>-->
          <!--                <a-select-option value="2">2</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :span="12">
            <a-form-item :label="$t('generic.ParentFunctionCode')" v-bind="formItemLayout">
              <a-select
                      size="small"
                      show-search
                      allow-clear
                      placeholder="当前Generic配置页面的左边一级菜单(字母菜单),可不填"
                      :options="parentGeMenuSelect.map(item => ({ value: item.funcCode, label: item.funcName }))"
                      v-decorator="[
                  'geParentMenuCode',
                  {rules: [{ required: false, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionCode')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      placeholder="不填写父菜单，默认新建父级菜单(字母菜单),否则新建二级菜单"
                      v-decorator="[
                  'geMenuCode',
                  {rules: [{ required: false, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>


          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionName')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      placeholder="菜单(字母菜单)显示名称"
                      v-decorator="[
                  'geMenuName',
                  {rules: [{ required: false, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>



          <a-col :span="24">{{ $t('generic.UserMenu') }}</a-col>

          <!--          <a-col :span="12">-->
          <!--            <a-form-item :label="$t('generic.FunctionName')" v-bind="formItemLayout">-->
          <!--              <a-input-->
          <!--                  size="small"-->
          <!--                  v-decorator="[-->
          <!--                  'menuName',-->
          <!--                  {rules: [{ required: true, message: $t('publicLang.Required') }]}-->
          <!--                ]"-->
          <!--              />-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :span="12">-->
          <!--            <a-form-item :label="$t('generic.FunctionLevel')" v-bind="formItemLayout">-->
          <!--              <a-select-->
          <!--                  style="width: 100%"-->
          <!--                  size="small"-->
          <!--                  @change="menuLevelChang"-->
          <!--                  v-decorator="[-->
          <!--                      'menuLevel',-->
          <!--                    {rules: [{ required: true, message: $t('publicLang.Required') }]}-->
          <!--                    ]">-->
          <!--                <a-select-option value="1">1</a-select-option>-->
          <!--                <a-select-option value="2">2</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :span="12">-->
          <!--            <a-form-item :label="$t('generic.ParentFunctionCode')" v-bind="formItemLayout">-->
          <!--              <a-input-->
          <!--                  size="small"-->
          <!--                  :disabled="menuLevelDis"-->
          <!--                  v-decorator="[-->
          <!--                  'parentMenuCode',-->
          <!--                  {rules: [{ required: !menuLevelDis, message: $t('publicLang.Required') }]}-->
          <!--                ]"-->
          <!--              />-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :span="12">-->
          <!--            <a-form-item :label="$t('generic.FunctionURL')" v-bind="formItemLayout">-->
          <!--              <a-input-->
          <!--                  size="small"-->
          <!--                  v-decorator="[-->
          <!--                  'menuUrl'-->
          <!--                ]"-->
          <!--              />-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->


          <a-col :span="12">
            <a-form-item :label="$t('generic.ParentFunctionCode')" v-bind="formItemLayout">
              <a-select
                      size="small"
                      show-search
                      allow-clear
                      placeholder="用户一级菜单"
                      :options="parentMenuSelect.map(item => ({ value: item.funcCode, label: item.funcName }))"
                      v-decorator="[
                  'parentMenuCode',
                  {rules: [{ required: false, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionCode')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      placeholder="用户二级菜单"
                      v-decorator="[
                  'menuCode',
                  {rules: [{ required: false, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>


          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionName')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      placeholder="用户菜单显示名称"
                      v-decorator="[
                  'menuName',
                  {rules: [{ required: false, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>


          <a-col :span="24">{{ $t('generic.RelationTable') }}</a-col>

          <a-col :span="12">
            <a-form-item label="ForeignTable" v-bind="formItemLayout">
              <!--              <a-input-->
              <!--                      size="small"-->
              <!--                      v-decorator="[-->
              <!--                  'foreignTable',-->
              <!--                ]"-->
              <!--              />-->
              <a-select
                      size="small"
                      v-decorator="[
                        'foreignTable',
                         {rules: [{ required: false, message: $t('publicLang.Required') }]}
                       ]"
                      show-search
                      allow-clear
                      mode="combobox"
                      placeholder="关联表,默认 关联表UID主键 关联 当前表的外键（e.g.: T_ASN_HEADER） "
                      :options="tableSelect.map(value => ({ value, label: value }))"
                      @change="foreignTableSelectChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="ExtAssoColumn" v-bind="formItemLayout">
              <a-select
                      size="small"
                      v-decorator="[
                        'extAssoColumn',
                         {rules: [{ required: false, message: $t('publicLang.Required') }]}
                       ]"
                      show-search
                      allow-clear
                      mode="combobox"
                      placeholder="当前表的外键 （e.g.: ASN_HEADER_UID）"
                      :options="extAssoColumnSelect.map(value => ({ value, label: value }))"
              />
            </a-form-item>
          </a-col>

        </a-form>
      </a-row>
    </a-modal>

    <a-modal
      :title="$t('generic.ConfigSQL')"
      v-model="configBySqlVisible"
      width="60%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button type="primary" :loading="configBySqlGenerateLoading" @click="generateConfigBySql">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-textarea
        v-model="configBySqlText"
        :auto-size="{ minRows: 12, maxRows: 18 }"
        placeholder="Please input SQL"
      />
    </a-modal>



  </div>
</template>
<script>
import dbSchema from "./subGeneric/dbSchema.vue";
import pageProperty from "./subGeneric/pageProperty.vue";
import queryCondition from "./subGeneric/queryCondition.vue";
import genericSql from "./subGeneric/genericSql.vue";
import beHavior from "./subGeneric/beHavior.vue";
import subPage from "./subGeneric/subPage.vue";
import searchTml from "./subGeneric/searchTml.vue";

import ajax from "../../api/ajax";
import api from "../../api/url";
import moment from "moment";
import AModal from "ant-design-vue/es/modal/Modal";
import SubMenu from "./subGeneric/SubMenu.vue";
export default {
  components: {
    searchTml,
    AModal,
    dbSchema,
    pageProperty,
    queryCondition,
    genericSql,
    beHavior,
    subPage,
    SubMenu
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.validateLogin = this.$form.createForm(this);
  },
  data() {
    return {
      genericSearchVal: null,
      geMenuLevelDis: false,
      menuLevelDis: false,
      createGenericForm: this.$form.createForm(this),
      appendDelGenericForm: this.$form.createForm(this),
      createGenericVis: false,
      appendDeleteVisGenData: false,
      appendDeleteVisGenDataType: '',
      maskClosable: false,
      strKey: 1,
      pageSize: 5,
      visibleAddList: false, // 是否新增弹窗
      targetGenericTitle: "All", // 点击当前的Title
      scopedSlotsArray: [
        "GenericName",
        "module",
        "isDefaultMod",
        "Status",
        "Function",
        "PageTitle",
        "Description",
        "SubPage",
        "Creator",
        "CreateDate",
        "Modifier",
        "ModiyDate"
      ], // gerenic header表头name
      animated: false, // 关关闭切换动画
      nopagination: false, // 取消分页
      customStyle: "border: 0;overflow: hidden",
      collapsed: true,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      }, // label 设置
      genericList: [], // genericHeaderListJson
      genericHeaderLoading: true,
      genericHeaderPage: {
        totalElements: 10, // genericheader 总条数
        genericCurrent: 1
      },
      genericFrom: {},
      ModulesList: [], // 模块
      functionList: [],
      loadingBtn: false,
      editInitialValue: {},
      uid: "",
      selectedRowKeys: [],
      copyDisabled: false,
      selectedRowsList: [], // genericHeader 以选中的
      pagedbSelectList: [], // sbschema选中的传给page proprtty
      gmcMenulist: [],
      currentPage: 1,
      disabledModule: false,
      funcCode: "",
      tabelText: {
        emptyText: "No record found"
      },
      targetUidClass: "",
      funcCodeType: "", // 区分是module subModule
      moduleCodeSelect:[],
      tableSelect:[],
      subModuleCodeSelect:[],
      menuSelect:[],
      geMenuSelect:[],
      parentMenuSelect:[],
      parentGeMenuSelect:[],
      selectedFuncCode: null,
      extAssoColumnSelect : [],
      selectedModuleCode:'',
      configBySqlVisible: false,
      configBySqlText: "",
      configBySqlUid: null,
      configBySqlGmcUid: null,
      configBySqlGenerateLoading: false,
      configBySqlSaveLoading: false,
      currentGmcHasSql: false,
    };
  },

  created() {
    this.menuInit();
    this.listInit();
  },
  watch: {
    targetUidClass(val) {
      this.loadCurrentGmcSqlStatus(val);
    },
    configBySqlVisible(val) {
      if (!val) {
        this.selectedRowKeys = [];
        this.selectedRowsList = [];
        if (this.$refs.refDbSchema) {
          this.$refs.refDbSchema.initTable();
        }
        if (this.$refs.refQueryCondition) {
          this.$refs.refQueryCondition.iniFreshTable(false);
        }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: "",
          width: 25,
          dataIndex: "isDefaultMod",
          scopedSlots: { customRender: "isDefaultMod" }
        },
        {
          title: this.$t("generic.GenericName"),
          dataIndex: "GenericName",
          scopedSlots: { customRender: "GenericName" }
        },
        {
          title: this.$t("generic.Module"),
          dataIndex: "subModule",
          scopedSlots: { customRender: "module" }
        },
        {
          title: this.$t("generic.Status"),
          dataIndex: "Status",
          scopedSlots: { customRender: "Status" }
        },
        {
          title: this.$t("generic.Function"),
          dataIndex: "FunctionValue",
          scopedSlots: { customRender: "Function" }
        },
        {
          title: this.$t("generic.PageTitle"),
          dataIndex: "PageTitle",
          scopedSlots: { customRender: "PageTitle" }
        },
        {
          title: this.$t("generic.Description"),
          dataIndex: "Description",
          scopedSlots: { customRender: "Description" }
        },
        {
          title: this.$t("generic.Creator"),
          dataIndex: "Creator",
          scopedSlots: { customRender: "Creator" }
        },
        {
          title: this.$t("generic.CreateDate"),
          dataIndex: "CreateDate",
          scopedSlots: { customRender: "CreateDate" }
        },
        {
          title: this.$t("generic.Modifier"),
          dataIndex: "Modifier",
          scopedSlots: { customRender: "Modifier" }
        },
        {
          title: this.$t("generic.ModifyDate"),
          dataIndex: "ModiyDate",
          scopedSlots: { customRender: "ModiyDate" }
        }
      ];
    } // tabel Header
  },
  methods: {
    foreignTableSelectChange(value){
      let tableName = this.createGenericForm.getFieldsValue().tableName;
      console.info(tableName)
      ajax.get(api.GENERICBASICCONFIGCLOUMN,{tableName: tableName}).then(res=>{
        if(res.code == 200){
          this.extAssoColumnSelect = res.data;
        }
      })
    },
    moduleCodeSelectChange(value){
      ajax.get(api.GENERICBASICCONFIGSUBMODULEDATA,{moduleCode:value}).then(res=>{
        if(res.code == 200){
          this.subModuleCodeSelect = res.data;
        }
      })
    },
    openConfigBySql() {
      if (this.selectedRowsList.length !== 1) {
        this.$customMessage.warning(this.$t("publicLang.pleaseOneOnly"));
        return;
      }
      const gmcUid = this.selectedRowsList[0].UID;
      this.configBySqlVisible = true;
      this.configBySqlGmcUid = gmcUid;
      this.configBySqlUid = null;
      this.configBySqlText = "";
      ajax.get(api.GENERICMASTERCONFIGSQL, { gmcUid: gmcUid }).then(res => {
        if (res.code === 200 && res.data) {
          this.configBySqlUid = res.data.uid;
          this.configBySqlText = res.data.sql || "";
          this.currentGmcHasSql = !!res.data.uid;
        } else {
          this.$customMessage.error(res.msg || "Load SQL failed");
        }
      });
    },
    saveConfigBySql() {
      if (!this.configBySqlGmcUid) {
        this.$customMessage.warning("Please select one record");
        return;
      }
      this.configBySqlSaveLoading = true;
      const params = {
        uid: this.configBySqlUid,
        gmcUid: this.configBySqlGmcUid,
        sql: this.configBySqlText || ""
      };
      ajax.post(api.GENERICMASTERCONFIGSQLSAVE, params).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg || "Saved");
          this.configBySqlUid = this.configBySqlUid || (res.data && res.data.uid);
          this.currentGmcHasSql = true;
        } else {
          this.$customMessage.error(res.msg || "Save failed");
        }
      }).finally(() => {
        this.configBySqlSaveLoading = false;
      });
    },
    generateConfigBySql() {
      if (!this.configBySqlGmcUid) {
        this.$customMessage.warning("Please select one record");
        return;
      }
      const params = {
        uid: this.configBySqlUid,
        gmcUid: this.configBySqlGmcUid,
        sql: this.configBySqlText || ""
      };
      this.configBySqlGenerateLoading = true;
      ajax.post(api.GENERICMASTERCONFIGSQLGENERATE, params).then(res => {
        if (res.code === 200) {
          const schemaCount = res.schemaCount || (res.data && res.data.schemaCount) || 0;
          const queryCount = res.queryCount || (res.data && res.data.queryCount) || 0;
          this.currentGmcHasSql = true;
          this.$message.success(`Generate success, schema: ${schemaCount}, query: ${queryCount}`);
        } else {
          this.$customMessage.error(res.msg || "Generate failed");
        }
      }).finally(() => {
        this.configBySqlGenerateLoading = false;
      });
    },
    refreshTab(){
      this.targetUidClass = null
      this.$store.commit("upUid", { uid: null });
      this.targetGenericTitle = null
      this.funcCode =  "";
      this.currentPage = 1;
      this.genericHeaderPage.genericCurrent = 1;
      this.listInit(1);
      this.genericChage(1)
      this.$nextTick(() => {
        const activeItems = document.querySelectorAll('.ant-menu-item-selected, .ant-menu-submenu-selected');
        activeItems.forEach(item => {
          item.classList.remove('ant-menu-item-selected', 'ant-menu-submenu-selected');
        });
      });
    },
    clearRedisCache(){
      ajax.get(api.CLEARREDISCACHE).then(res => {
        if(res.code == 200){
          this.$message.success(res.msg);
        }else{
          this.$customMessage.error(res.msg)
        }
      });
    },
      cleardata(){

      },
      levelChang(v){
          if(v == 1){
              this.geMenuLevelDis = true
          }else{
              this.geMenuLevelDis = false
          }

      },
      menuLevelChang(v){
          if(v == 1){
              this.menuLevelDis = true
          }else{
              this.menuLevelDis = false
          }
      },
      genericDataCancel(type){
        if(type == 'a'){
            this.createGenericVis = false
            this.createGenericForm.resetFields();
        }else{
            this.appendDeleteVisGenData = false
            this.appendDelGenericForm.resetFields();
            this.appendDeleteVisGenDataType = ''
        }
    },
    createGenericBtn(){
      this.createGenericVis = true
      ajax.get(api.GENERICBASICCONFIGDATA).then(res=>{
        if(res.code == 200){
          this.moduleCodeSelect = res.data.moduleCodeList;
          this.tableSelect = res.data.tableNameAndViewNameList;
          this.subModuleCodeSelect = res.data.subModuleCodeList;
          this.menuSelect = res.data.menu;
          this.geMenuSelect = res.data.geMenu;
          this.parentMenuSelect = res.data.parentMenu;
          this.parentGeMenuSelect = res.data.parentGeMenu;
        }
      })
    },
    appendGenericData(type){
      this.appendDeleteVisGenDataType = type
      this.appendDeleteVisGenData = true
    },
    subMitAppendDelGeneric(){
        this.appendDelGenericForm.validateFields((err, values) => {
            if (err) {
                return
            }
            if(this.appendDeleteVisGenDataType == 'add'){
              ajax.post(api.GENERICAPPENDDATA,values).then(res=>{
                  if(res.code == 200){
                      this.appendDeleteVisGenData = false
                      this.appendDelGenericForm.resetFields();
                      this.appendDeleteVisGenDataType = ''
                      this.$message.success(res.msg);
                  }else{
                      this.$customMessage.error(res.msg)
                  }
              })
            }else if(this.appendDeleteVisGenDataType == 'delete'){
                ajax.post(api.GENERICDELETIONDATA,values).then(res=>{
                    if(res.code == 200){
                        this.appendDeleteVisGenData = false
                        this.appendDelGenericForm.resetFields();
                        this.appendDeleteVisGenDataType = ''
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.error(res.msg)
                    }
                })
            }
        })
    },

    subMitCreateGeneric(){
          this.createGenericForm.validateFields((err, values) => {
              if (err) {
                  return
              }
              ajax.post(api.GENERICBASICDATA,values).then(res=>{
                  if(res.code == 200){
                      this.createGenericVis = false
                      this.createGenericForm.resetFields();
                      this.$message.success(res.msg);
                  }else{
                      this.$customMessage.error(res.msg)
                  }
              })
          });
      },
    selectMenuApi(v) {
      this.targetUidClass = null
      this.$store.commit("upUid", { uid: null });
      this.targetGenericTitle = null
      this.funcCode = v.key;
      this.listInit(1);
    },
    //      generic Menu
    menuInit() {
      ajax.get(api.GETGMCMENU).then(res => {
        this.gmcMenulist = res.data;
        this.gmcMenulist.forEach((v, i) => {
          if (v.children.length == 0) {
            delete v.children;
          } else {
            this.fnGmcMenufliter(v.children);
          }
        });
      });
    },
    fnGmcMenufliter(arr) {
      arr.forEach((v, i) => {
        if (v.children.length == 0) {
          delete v.children;
        } else {
          this.fnGmcMenufliter(v.children);
        }
      });
    },
    //      复制Generic
    copyGeneric() {
      this.copyDisabled = true;
      if (this.selectedRowsList.length != 1) {
        this.$customMessage.warning(this.$t("publicLang.PleaseSltAtleast"));
        this.copyDisabled = false;
        return;
      }
      let params = {
        uid: this.selectedRowsList[0].UID
      };
      ajax.post(api.COPY, params).then(res => {
        if (res.code === 200) {
          this.listInit();
          this.copyDisabled = false;
        }
      });
    },
    //      发布generic
    fabuGeneric() {
      if (
        this.selectedRowsList.length < 0 ||
        this.selectedRowsList.length === 0
      ) {
        this.$customMessage.warning(this.$t("publicLang.PleaseSltAtleast"));
        return;
      } else {
        let uidArray = [];
        for (let index in this.selectedRowsList) {
//            let status = this.selectedRowsList[index].Status
//          if (status === "Inactive" || status === "Issued") {
//            this.$customMessage.warning(this.$t("generic.NotInactive"));
//            return
//          }
//          if (status === "New" || status === "New_Copy" || status == "Copied"){
//            uidArray.push(this.selectedRowsList[index].UID);
//          }
            uidArray.push(this.selectedRowsList[index].UID);
        }
        let params = {
          uids: uidArray
        };
        ajax.put(api.ISSUE, params).then(res => {
          if (res.code === 200) {
            this.listInit(this.currentPage);
          }
        });
      }
    },
    tabsChange(index) {
      this.$store.commit("uptabs", { tabs: index });
    },
    getdbselectlist(data) {
      this.pagedbSelectList = data;
    },
    genericSearch(){
      this.listInit()
    },
    //    genericListeditInitialValue
    listInit(pageNum = 1) {
      this.genericHeaderLoading = true;
      let params = {
        pageNum: pageNum, // 当前页码
        pageSize: "5", // 当前页数
        keyword: this.genericSearchVal
      };
      params.subModuleCode = this.funcCode;
      ajax.get(api.FETCH, params).then(res => {
        let genericList = res.data;
        this.genericList = genericList.content;
        for (let i in this.genericList) {
          if (this.genericList[i].CreateDate == null) {
            this.genericList[i].CreateDate = "-";
          } else {
            this.genericList[i].CreateDate = moment(
              this.genericList[i].CreateDate
            ).format("YYYY-MM-DD HH:mm:ss");
          }
          if (this.genericList[i].ModiyDate == null) {
            this.genericList[i].ModiyDate = "-";
          } else {
            this.genericList[i].ModiyDate = moment(
              this.genericList[i].ModiyDate
            ).format("YYYY-MM-DD HH:mm:ss");
          }
        }
        this.genericHeaderPage.totalElements = parseInt(
          genericList.totalElements
        );
        this.genericHeaderLoading = false;
        this.selectedRowKeys = [];
        this.selectedRowsList = [];
      });
    },
    // 分页
    genericChage(page) {
      this.currentPage = page;
      this.genericHeaderLoading = true;
      this.listInit(page);
    },
    //    添加genericMOdeule function 弹窗显示
    AddEditGeneric(type) {
      //      获取模块
      ajax.get(api.GETMODULEDROPDATA).then(res => {
        this.ModulesList = res.data;
      });
      ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
        if (res.code === 200) {
          this.functionList = res.data;
        }
      });
      if (type === "add") {
        this.editInitialValue = "";
        this.uid = "";
        this.visibleAddList = true;
        this.disabledModule = false;
      } else {
        this.selectedRowKeys = [];
        if (this.selectedRowsList.length == 1) {
          this.editInitialValue = this.selectedRowsList[0];
          this.uid = this.editInitialValue.UID;
          this.selectedRowKeys = [];
          this.visibleAddList = true;
          this.disabledModule = true;
        } else {
          this.$customMessage.warning(this.$t("publicLang.pleaseOneOnly"));
        }
      }
    },
    //    删除genericHeader
    deleteGeneric() {
      if (this.selectedRowsList.length > 0) {
        let paramsArray = [];
        for (let ii in this.selectedRowsList) {
          paramsArray.push(this.selectedRowsList[ii].UID);
        }
        let params = {
          uid: paramsArray
        };
        ajax.post(api.DELETE, params).then(res => {
          if (res.code === 200) {
            this.listInit();
            this.selectedRowKeys = [];
          }
        });
      } else {
        this.$customMessage.warning(this.$t("publicLang.pleaseOneOnly"));
      }
    },
    //      新增编辑
    getGenericConfig() {

      console.info('AABBCC')

      this.form.validateFields((err, params) => {
        this.loadingBtn = true;
        if (this.uid != "") {
          params.uid = this.uid;
        }
        if (!err) {
          console.info(params.useViewSql)
          let moduleVal = params.module;
          params.module = moduleVal[0];
          params.subModule = moduleVal[1];
          params.isPaging = params.isPaging ? "1" : "0";
          params.isDefaultMod = params.isDefaultMod ? "1" : "0";
          params.isOption = params.isOption ? "1" : "0";
          params.isUserView = params.isUserView ? "1" : "0";
          params.useViewSql = params.useViewSql ? "1" : "0";
          ajax.post(api.SAVE, params).then(res => {
            if (res.code == 501) {
              this.$customConfirm({
                title: "point out",
                content: res.msg,
                okText: this.$t('publicLang.Confirm'),
                cancelText: this.$t('publicLang.Cancel'),
                onOk() {},
                onCancel() {}
              });
            }
            if (res.code === 200) {
              this.loadingBtn = false;
              this.currentPage =
                this.currentPage === "" ? "1" : this.currentPage;
              this.listInit(this.currentPage);
              this.visibleAddList = false;
              ++this.strKey;
              this.$forceUpdate();
              this.form.resetFields();
            }
          });
        }
        this.loadingBtn = false;
      });
    },
    //      重置
    resetting() {
      this.ModulesList = [];
      this.form.resetFields();
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    customRowEvent(record, index) {
      return {
        on: {
          click: () => {
            this.targetUidClass = record.UID;
            this.pagedbSelectList = [];
            this.$store.commit("upUid", { uid: record.UID });
            this.targetGenericTitle = record.GenericName;
            this.selectedModuleCode = record.Module
          },
          dblclick: () => {
            this.selectedRowsList = [];
            this.selectedRowKeys = [];

            this.selectedRowsList.push(record);
            this.selectedRowKeys.push(index);

            this.AddEditGeneric("Edit");
          }
        }
      };
    },
    rowClassName(record) {
      return record.UID === this.targetUidClass ? "bg" : "";
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRowsList = selectedRows;
    },
    loadCurrentGmcSqlStatus(gmcUid) {
      if (!gmcUid) {
        this.currentGmcHasSql = false;
        return;
      }
      ajax.get(api.GENERICMASTERCONFIGSQL, { gmcUid }).then(res => {
        this.currentGmcHasSql = !!(res.code === 200 && res.data && res.data.uid);
      }).catch(() => {
        this.currentGmcHasSql = false;
      });
    },
    clearSelectedData(){
      this.pagedbSelectList = []
      this.$refs.refDbSchema.clearSelectedRowKeys();
    },
  }
};
</script>
<style lang="less">
  /* 覆盖所有层级的选中样式 */
  #gmc-menu-container.generic-left-menu::v-deep .ant-menu-item-selected,
  #gmc-menu-container.generic-left-menu::v-deep .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: #595959 !important;  /* 默认文字颜色 */
    background: transparent !important;
    font-weight: normal !important;
  }

  #generic {
  .bg {
    background: darkseagreen !important;
  }
  .cc {
    background: #fff;
  }
  .hh {
    background: #e7eef8;
  }
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  .generic-left {
    .generic-left-menu {
      overflow: hidden;
      overflow-y: auto;
      height: 85vh;
    }
    .collapsed-left {
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #e7eef8;
    }
    .ant-menu-inline {
      border-right: none;
    }
    .menu-s {
      background: #f0f2f5;
      color: #333;
    }
    .ant-menu-submenu > .ant-menu {
      background: #f0f2f5;
    }
  }
  .generic-right {
    flex: 1;
    background: #fff;
    padding: 4px;
    overflow-y: auto;
    .componts-btn {
      margin: 8px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .componts-btn-left {
        button {
          margin-right: 10px;
        }
      }
    }
  }
}
.ant-table-filter-dropdown-btns {
  display: flex;
  a {
    margin-left: 4px;
  }
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: none;
}
.ant-collapse-content > .ant-collapse-content-box {
  padding: 0;
}
</style>
